import { render, staticRenderFns } from "./sDataviewList.vue?vue&type=template&id=4e5a36a8"
import script from "./sDataviewList.vue?vue&type=script&lang=js"
export * from "./sDataviewList.vue?vue&type=script&lang=js"
import style0 from "./sDataviewList.vue?vue&type=style&index=0&id=4e5a36a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports